window.addEventListener('frame-ready', init)

function init() {

    const buttons = document.querySelectorAll('.js-rating svg')
    if(!buttons.length) return

    function clickRating(e) {
        e.preventDefault();
        var button = e.target;
        var product = button.dataset.product
        var value = button.dataset.value
        var url = '/action/rating/' + product + '/' + value

        fetch(url, {
            method: 'POST',
            headers: {
                "Accept": "application/json; charset=utf-8",
                "x-requested-with": "XMLHttpRequest"
            },
        })
            .then(res => res.json())
            .then(res => {
                if (res.success != false) {
                    let rating = res.ratingAvg

                    buttons.forEach(function (item) {
                        var value = item.dataset.value
                        let path = item.querySelector('path')

                        if (value <= rating) {
                            path.setAttribute('style', 'fill:currentColor');
                        } else {
                            path.setAttribute('style', 'fill:transparent');
                        }
                    });
                }
            })
    }

    buttons.forEach(function (item) {
        item.addEventListener("click", clickRating, false);
    });

}


